<template>
  <div class="wrap">
    <!-- 标题 -->
    <h1 class="common-header">{{ $t('1360') }}</h1>
    <div class="by-content">
      <!-- 右侧列表 -->
      <div class="org-content">
        <div class="form-wrap">
          <div>
            <el-input
              type="text"
              v-model="form.name"
              :placeholder="$t('da8c681e')"
              prefix-icon="el-icon-search"
              clearable
            ></el-input>
            <!-- 查询 -->
            <el-button type="primary" class="query" @click="handlerQuery">{{ $t('80') }}</el-button>
            <el-checkbox class="query" v-model="is_all" @change="handlerQuery">{{ $t('b876c049') }}</el-checkbox>
          </div>
          <!-- 新建班次 -->
          <el-button type="primary" @click="openEdit(1)" v-if="$p('menu.work.frequency.edit')">{{
            $t('1361')
          }}</el-button>
        </div>
        <!-- 表格数据 -->
        <div class="table-wrap">
          <el-table :data="tableData" border style="width: 100%" v-load="loading">
            <!-- 班次名称 -->
            <el-table-column prop="name" :label="$t('1362')"></el-table-column>
            <!-- 考勤时间 -->
            <el-table-column :label="$t('1363')">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.start }} ~ {{ scope.row.end }}
                  <label v-if="scope.row.end_mark">( {{ scope.row.end_mark }} )</label>
                </span>
              </template>
            </el-table-column>
            <!-- 班次名称 -->
            <!-- <el-table-column prop="creator_staff_name" :label="$t('create_name')"></el-table-column> -->
            <!-- 操作 -->
            <el-table-column fixed="right" :label="$t('70')" width="180px">
              <template slot-scope="{ row }" v-if="row.id !== '1'">
                <el-button type="text" :disabled="row.is_supervisor" @click="openEdit(0, row)">{{
                  $t('64')
                }}</el-button>
                <el-button
                  type="text"
                  @click="openEdit(2, row)"
                  v-if="$p('menu.work.frequency.edit')"
                  :disabled="!row.is_supervisor"
                  >{{ $t('71') }}</el-button
                >
                <el-button
                  v-if="row.is_default !== 1 && $p('menu.work.frequency.delete')"
                  :disabled="!row.is_supervisor"
                  type="text"
                  @click="handleDelSetting(row)"
                  >{{ $t('65') }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="page-wrap">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.page"
              :page-sizes="[20, 40, 80, 100]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑新建 -->
    <Edit ref="edit" @updateList="getShiftList" />
  </div>
</template>

<script>
// 班次列表
import { shiftList, shiftDel } from 'api/frequency'
import Edit from './modal'
export default {
  components: {
    Edit
  },
  data() {
    return {
      is_all: false,
      form: {
        is_all: 1,
        name: ''
      },
      page: {
        page: 1,
        size: 20,
        total: 0
      },
      loading: false,
      tableData: []
    }
  },
  created() {
    this.getShiftList()
  },
  methods: {
    // 分页相关
    handleSizeChange(size) {
      this.page.size = size
      this.getShiftList()
    },
    handleCurrentChange(currentPage) {
      this.page.page = currentPage
      this.getShiftList()
    },
    // 获取数据
    async getShiftList() {
      this.loading = true
      this.form.is_all = this.is_all ? 0 : 1
      const res = await shiftList({
        ...this.form,
        ...this.page
      })
      this.loading = false
      this.tableData = res.data.result
      this.page.total = res.data.count
    },
    // 查询
    handlerQuery() {
      this.page.page = 1
      this.getShiftList()
    },
    // 删除
    async handleDelSetting(row) {
      await shiftDel(row)
      this.getShiftList()
    },
    // open create
    // 1 新建 2 编辑 0查看
    openEdit(str, info) {
      const { $t } = this
      let title = this.$t('876c0495')
      if (str === 1) title = this.$t('1361')
      if (str === 2) title = this.$t('1364')
      const msg = { title, type: str, info }
      if (str === 2) {
        // info.is_rest 0为false 1为true
        info.is_rest = !!Number(info.is_rest)
        this.$confirm($t('1727'), $t('1726'), {
          confirmButtonText: $t('131'),
          cancelButtonText: $t('66')
        }).then(async () => {
          this.$refs.edit.init(msg, info.is_default)
        })
      } else {
        this.$refs.edit.init(msg)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.by-content {
  height: calc(100% - 60px);
  overflow: auto;
  .form-wrap {
    margin: 0 0 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .query {
      margin-left: 15px;
    }
  }
}
.radio-wrap {
  line-height: 60px;
}
.by-list-title {
  line-height: 1;
  height: 18px;
  color: $menuBg;
  font-weight: 600;
}
</style>
